// import React, { useState } from 'react';
// import { Helmet } from 'react-helmet';
// import { useNavigate } from 'react-router-dom';
// import Icon from '../../components/AppIcon';
// import Button from '../../components/ui/Button';
// import { cn } from '../../utils/cn';
// import LoginForm from './components/LoginForm';
// import SignupForm from './components/SignupForm';

// const SignupPage = () => {
//     const navigate = useNavigate();
//     const [activeTab, setActiveTab] = useState('signup');
//     const [showPassword, setShowPassword] = useState(false);
//     const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//     const [formData, setFormData] = useState({
//         fullName: '',
//         phone: '',
//         password: '',
//         confirmPassword: ''
//     });

//     const handleInputChange = (e) => {
//         const { name, value } = e?.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleSubmit = (e) => {
//         e?.preventDefault();
//         // Form submission logic here
//         console.log('Form submitted:', formData);
//     };

//     const handleLoginClick = () => {
//         // Navigate to login or switch tab
//         setActiveTab('login');
//     };

//     return (
//         <>
//             <Helmet>
//                 <title>إنشاء حساب - مطعم</title>
//             </Helmet>
//             <main className="min-h-screen bg-white">
//                 <div className="min-h-screen grid lg:grid-cols-2">



//                     {/* Right Side - Form */}
//                     <div className="flex items-center justify-center px-6 bg-[#FAFAFA]">
//                         <div className="w-full max-w-md">

//                             <main className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4 py-4 ">
//                                 <div className="w-full max-w-md">
//                                     {/* Logo */}
//                                     <div className="flex justify-center mb-4">
//                                         <div className="w-16 h-16 bg-primary rounded-[4px] flex items-center justify-center ">
//                                             <img className='rounded-[4px]' src='/assets/images/logo.jpeg' />
//                                         </div>
//                                     </div>
//                                     {/* Welcome Text */}
//                                     <h1 className="text-center text-[#6B7280] font-[cairo] text-lg font-medium text-foreground mb-4">
//                                         مرحبا بك في تطبيقنا </h1>

//                                     <div className="w-full bg-[#EDEDED] p-1 rounded-full flex mb-4 font-[cairo]">
//                                         <button onClick={() => setActiveTab('login')}
//                                             className={cn("flex-1 py-2.5 text-sm font-medium rounded-full transition-all duration-200", activeTab === 'login' ? "bg-white text-black shadow-sm" : "bg-transparent text-gray-500")} >
//                                             تسجيل دخول </button>
//                                         <button
//                                             onClick={() => setActiveTab('signup')}
//                                             className={cn("flex-1 py-2.5 text-sm font-medium rounded-full transition-all duration-200", activeTab === 'signup' ? "bg-white text-black shadow-sm" : "bg-transparent text-gray-500")} >
//                                             إنشاء حساب </button>
//                                     </div>
//                                     {/* Form */}
//                                     {activeTab === 'login' ? <LoginForm /> : <SignupForm />}

//                                     {/* Terms and Privacy */}
//                                     <div className="text-center mt-4 text-xs text-muted-foreground leading-relaxed font-[cairo]">
//                                         <span>بالمتابعة، أنت توافق على </span>
//                                         <button className="text-primary underline hover:no-underline"> شروط الاستخدام </button> <span> و</span> <button className="text-primary underline hover:no-underline"> سياسة الخصوصية </button>
//                                     </div>
//                                 </div>
//                             </main>

//                         </div>
//                     </div>

//                     {/* Left Side - Image (Desktop Only) */}
//                     <div className="hidden lg:block relative overflow-hidden bg-[#FAFAFA]">
//                         <div className="h-full w-full overflow-hidden ">
//                             <img
//                                 src="/assets/images/half.jpg"
//                                 alt="Auth"
//                                 className="w-full h-full object-cover"
//                             />
//                         </div>
//                     </div>

//                 </div>
//             </main>
//         </>
//     );
// };

// export default SignupPage;
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { cn } from '../../utils/cn';
import LoginForm from './components/LoginForm';
import SignupForm from './components/SignupForm';
import GoogleRegisterButton from './components/GoogleRegisterButton';

const SignupPage = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('signup');

    return (
        <>
            <Helmet>
                <title>إنشاء حساب - يسلمو</title>
            </Helmet>
            <main className="min-h-screen bg-white">
                <div className="min-h-screen grid lg:grid-cols-2">

                    {/* Right Side - Form */}
                    <div className="flex items-center justify-center px-4 md:px-6 bg-white">
                        <div className="w-full max-w-md">

                            <div className="min-h-screen flex flex-col justify-center py-8">
                                {/* Logo */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-16 h-16 bg-primary rounded-[4px] flex items-center justify-center ">
                                        <img className='rounded-[4px]' src='/assets/images/logo.jpeg' alt="Logo" />
                                    </div>
                                </div>
                                {/* Welcome Text */}
                                <h1 className="text-center text-[#6B7280] font-[cairo] text-lg font-medium text-foreground mb-4">
                                    مرحبا بك في تطبيقنا
                                </h1>

                               <GoogleRegisterButton/>

                                {/* Tabs */}
                                <div className="w-[95%] mx-auto bg-[#EDEDED] p-1 rounded-full flex mb-4 font-[cairo]">
                                    <button
                                        onClick={() => setActiveTab('login')}
                                        className={cn(
                                            "flex-1 py-2.5  text-sm md:text-base font-medium rounded-full transition-all duration-200",
                                            activeTab === 'login' ? "bg-white text-black shadow-sm" : "bg-transparent text-gray-500"
                                        )}
                                    >
                                        تسجيل دخول
                                    </button>
                                    <button
                                        onClick={() => setActiveTab('signup')}
                                        className={cn(
                                            "flex-1 py-2.5 text-sm md:text-base font-medium rounded-full transition-all duration-200",
                                            activeTab === 'signup' ? "bg-white text-black shadow-sm" : "bg-transparent text-gray-500"
                                        )}
                                    >
                                        إنشاء حساب
                                    </button>
                                </div>

                                {/* Form */}
                                <div className="w-full">
                                    {activeTab === 'login' ? (
                                      <LoginForm key="login-form" />
                                    ) : (
                                      <SignupForm key="signup-form" />
                                    )}
                                </div>

                                {/* Terms and Privacy */}
                                <div className="text-center mt-4 text-xs md:text-sm text-muted-foreground leading-relaxed font-[cairo]">
                                    <span>بالمتابعة، أنت توافق على </span>
                                    <button
                                    onClick={() => navigate("/terms-and-conditions")}
                                    className="text-primary underline hover:no-underline">شروط الاستخدام</button>
                                    <span> و</span>
                                    <button
                                    onClick={() => navigate("/privacy-policy")}
                                    className="text-primary underline hover:no-underline">سياسة الخصوصية</button>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Left Side - Image (Desktop Only) */}
                    <div className="hidden lg:block relative overflow-hidden bg-[#FAFAFA]">
                        <img
                            src="/assets/images/half.jpg"
                            alt="Auth"
                            className="w-full h-full object-cover"
                        />
                    </div>

                </div>
            </main>
        </>
    );
};

export default SignupPage;